import { FC } from "react";
import { useSelector } from "react-redux";

import { Info, OneColored } from "@livechat/design-system-icons";
import { Icon, IconSource, SpacingToken, Text, Tooltip } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { selectLanguageLabels } from "store/entities/application-settings/selectors";
import { withVar } from "themes/helpers";

interface IProps {
  detectedLanguage: string | null;
}

const BaseLabel: FC<{ text: string; icon: IconSource; tooltipText: string }> = ({ text, icon, tooltipText }) => (
  <Flex inline alignItems="center" gap={withVar(SpacingToken.Spacing1)}>
    <Text>{text}</Text>
    <Tooltip triggerRenderer={<Icon source={icon} size="small" />} kind="invert">
      {tooltipText}
    </Tooltip>
  </Flex>
);

const NotDetected: FC = () => (
  <BaseLabel
    text="Not detected"
    icon={Info}
    tooltipText="The language couldn't be detected, or the ticket was created before the language detection feature was available."
  />
);

const DetectedLanguage: FC<{ language: string }> = ({ language }) => {
  const languages = useSelector(selectLanguageLabels);

  return (
    <BaseLabel
      text={languages[language] ?? "Unknown"}
      icon={OneColored}
      tooltipText="Language detected by Text Copilot"
    />
  );
};

export const TicketLanguageLabel: FC<IProps> = ({ detectedLanguage }) => {
  if (!detectedLanguage) {
    return <NotDetected />;
  }

  return <DetectedLanguage language={detectedLanguage} />;
};
